import React from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

import PrinterMappingForm from './PrinterMapping/PrinterMappingForm';

const message = defineMessages({
    objectName: 'Printer mapping',
});

const MappingSavePage = () => {
    const translate = useTranslate();
    const params = useParams();

    const queryParams = new URLSearchParams(location.search);
    const deviceId = queryParams.get('deviceId');
    const deviceName = queryParams.get('deviceName');
    const customerName = queryParams.get('customerName');
    const path = `?deviceId=${deviceId}&deviceName=${deviceName}&customerName=${customerName}`;

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: apiConfig.printerMapping,
        options: {
            getListUrl:
                generatePath(routes.DeviceTab.path, {
                    customerId: params.customerId,
                }) + path,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(errorMessage, translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    return (
        <PageWrapper
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.managerKitplay),
                    path: routes.listKitPlayDevicePage.path,
                },
                {
                    breadcrumbName: deviceName,
                    path: `${generatePath(routes.DeviceTab.path, {
                        customerId: params.customerId,
                    })}?deviceId=${deviceId}&deviceName=${encodeURIComponent(deviceName)}&customerName=${encodeURIComponent(customerName)}`,
                },
                { breadcrumbName: title },
            ]}
            loading={loading}
            title={title}
        >
            <PrinterMappingForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default MappingSavePage;
